var _defs, _title;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "300 400 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1299.903,
    height: 1023.307
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.190274, 0, 0, 1.204274, -880.696289, -174.750473)",
    style: {
      clipPath: "url(#clip-1)"
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "D")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    className: "cls-10",
    cx: 1075.488,
    cy: 560.587,
    r: 70.317,
    style: {
      fill: "rgb(255, 159, 94)",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    className: "cls-11",
    x2: 1114.558,
    style: {
      fill: "none",
      stroke: "rgb(53, 82, 121)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    },
    x1: 1034.622,
    y1: 566.183,
    y2: 566.183
  }), /*#__PURE__*/React.createElement("text", {
    id: "D",
    className: "cls-13",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: "54.585px",
      fontWeight: 700,
      letterSpacing: "0.54585px",
      lineHeight: "87.336px",
      perspectiveOrigin: "24.0469px 34px"
    },
    x: 1049.657,
    y: 497.568
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1057.808,
    y: 553.568,
    style: {
      fontSize: "54.6px",
      wordSpacing: 0,
      letterSpacing: "0.55px"
    }
  }, "D")), /*#__PURE__*/React.createElement("text", {
    id: "_35-52",
    "data-name": "35-52",
    className: "cls-14",
    style: {
      whiteSpace: "pre",
      fill: "rgb(53, 82, 121)",
      fontFamily: "Assistant-Bold, Assistant",
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 48,
      perspectiveOrigin: "38.4688px 18.5px"
    },
    x: 1030.99,
    y: 566.758
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1037.977,
    y: 597.758,
    style: {
      fontSize: 30,
      wordSpacing: 0
    }
  }, "35-52"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.662ac7dc8b5db48c807cb4af13299e2e.svg";
export { ForwardRef as ReactComponent };